import React from 'react';

export default function WithPlaceHolderAndKey(Component, placeHolder, key) {
  return class WithPlaceHolderAndKeyComponent extends React.Component {
    render() {
      return <Component dateKey={key} placeHolder={placeHolder} {...this.props} />;
    }
  };
}
